module.exports = __webpack_public_path__ + "img/applet.f3818f00.jpg";